import request from './request'

//删除订单
export const OrderDel = params => request.post('/Home/Order/order_del', params);

//取消订单
export const OrderCancel = params => request.post('/Home/Order/order_cancel', params);

//未支付订单重新支付
export const OrderPay = params => request.post('/Home/Order/order_pay', params);

//提交订单
export const SubmitOrder = params => request.post('/Home/Order/subimt_order', params);

//购物车购买待确认
export const GetOrderByCart = params => request.post('/Home/Order/cart_unconfirmed_order', params);

//立即购买待确认
export const GetOrderByBuy = params => request.post('/Home/Order/buy_unconfirmed_order', params);

//获取订单列表
export const GetOrder = params => request.post('/Home/Order/order_list', params);

//设置默认地址
export const DefAddress = params => request.post('/Home/UserContent/address_default', params);

//删除地址
export const DelAddress = params => request.post('/Home/UserContent/address_del', params);

//修改地址
export const EditAddress = params => request.post('/Home/UserContent/address_edit', params);

//添加地址
export const AddAddress = params => request.post('/Home/UserContent/address_add', params);

//获取收货地址
export const GetAddress = params => request.post('/Home/UserContent/address', params);

//上传头像
export const ImgUploader = params => request.post('/Home/UserContent/upload', params);

//找回密码
export const FindPwd = params => request.post('/Home/Login/forget_password', params);

//找回密码验证提交
export const CheckFindPwd = params => request.post('/Home/Login/forget_verification', params);

//找回密码验证码
export const SmsFindPwd = params => request.post('/Home/Login/forget_sms_code', params);

//设置新号码
export const CheckNewPhone = params => request.post('/Home/UserContent/setphone', params);

//新手机验证码
export const SmsNewPhone = params => request.post('/Home/UserContent/getnewphonecode', params);

//原手机验证
export const CheckOldPhone = params => request.post('/Home/UserContent/verificationphonecode', params);

//原手机验证码
export const SmsOldPhone = params => request.post('/Home/UserContent/getoldphonecode', params);

//原密码验证
export const CheckOldPwd = params => request.post('/Home/UserContent/verificationpass', params);

//设置新密码
export const SetNewPwd = params => request.post('Home/UserContent/setpass', params);

//添加至购物车
export const CartHandler = params => request.post('/Home/UserCart/cart', params);
//购物车列表
export const GetCart = params => request.put('/Home/UserCart/cart_list', params);

//获取用户信息
export const GetUserInfo = params => request.put('/Home/UserContent/user', params);
//修改用户信息
export const EditUserInfo = params => request.put('/Home/UserContent/update', params);

//短信验证
export const Smscode = params => request.post('/home/login/get_sms_vcode', params);

//获取区县
export const GetArea = params => request.post('/Home/UserContent/area', params);
//获取市
export const GetCity = params => request.post('/Home/UserContent/city', params);
//获取省份信息
export const GetProvince = params => request.post('/Home/UserContent/province', params);
//获取国家信息
export const GetCountry = params => request.post('/home/login/get_country', params);

//登录注册
export const Login = params => request.post('/home/login/login', params);
export const Register = params => request.post('/home/login/register', params);

//版权
export const Copyright = params => request.post('/home/Info/get_footer_info', params);

//联系我们
export const Feedback = params => request.post('/home/contact/feedback', params);

//简介
export const GetAboutUs = params => request.post('/home/Info/about', params);

//资源
export const GetResource = params => request.post('/home/Info/resource', params);

//产品
export const GetProductList = params => request.post('/home/product/product_list', params);
export const GetProductDetial = params => request.post('/home/product/product_detail', params);

//新闻
export const GetNews = params => request.post('/home/Info/news_detail', params);
export const GetHomeNews = params => request.post('/home/Info/get_index_news', params);

//案例
export const GetSolutions = params => request.post('/home/Info/solutions', params);
export const GetSolutionsDetail = params => request.post('/home/Info/solutions_detail', params);
export const GetHomeSolutions = params => request.post('/home/Info/get_index_sol', params);

//轮播图
export const GetBanner = params => request.post('/home/resources/get_banner', params);

//页脚
export const GetFooterProducts = params => request.post('/home/Info/get_footer_product_category', params);
export const GetFooterSolutions = params => request.post('/home/Info/get_footer_sol_category', params);
export const GetFooterResource = params => request.post('/home/Info/get_footer_resource_category', params);



// WEBPACK FOOTER //
// ./src/api/index.js